import camelCase from "lodash-es/camelCase";
import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import { footerInteractionTracking } from "../../../../../../../services/analytics.service";
import theme, { media } from "../../../../../../../theme";

import Link from "./components/Link";

export interface ILink {
  getLabel: () => string;
  imgSrc?: string;
  getUrl: () => string;
}

const LinksWrapper = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  a {
    min-height: 46px;
  }

  ${media.laptop} {
    a {
      min-height: initial;

      & > div {
        color: ${theme.colors.white};

        img {
          display: none;
        }
      }
      i {
        display: none;
      }
    }
  }
`;

export interface IProps {
  className?: string;
  linksList: ILink[];
}

export default class LinksList extends PureComponent<IProps> {
  public static defaultProps: Partial<IProps> = {
    className: "",
  };

  public render(): ReactNode {
    const { className, linksList } = this.props;

    return (
      <LinksWrapper className={className}>
        {linksList.map((link: ILink) => {
          return (
            !!link.getLabel() && (
              <Link
                key={`link-${link.getLabel()}`}
                label={link.getLabel()}
                to={link.getUrl()}
                onClick={(): void =>
                  footerInteractionTracking(camelCase(link.getLabel()))
                }
                imgSrc={link.imgSrc}
              />
            )
          );
        })}
      </LinksWrapper>
    );
  }
}
